export default theme => ({
  root: {},
  refreshButton: {
    margin: -theme.spacing.unit * 2
  },
  chartWrapper: {
    position: 'relative',
    height: '300px'
  },
  stats: {
    marginTop: theme.spacing.unit * 2,
    display: 'flex',
    justifyContent: 'center'
  },
  typeAccount: {
    textAlign: 'center',
    padding: theme.spacing.unit
  },
  typeAccountIcon: {
    color: theme.palette.common.neutral
  },
  progressWrapper: {
    height: '400px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textWrapper: {
    height: '400px',
    display: 'flex',
    justifyContent: 'center'
  }
});
